import React from 'react'

const ListCheck = () => {
  return (
    <svg viewBox="0 0 33.5 33.5">
      <polyline fill="none" stroke="#6EC18A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" points="8.3,15.7 14.6,23 32.5,1 "/>
      <path fill="none" stroke="#3F5063" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"  d="M28.1,16.7c0.9,5.6-1.8,11.2-6.8,14s-11.2,2.2-15.5-1.6s-5.9-9.7-3.9-15.1s7.1-8.9,12.8-8.9
	c1.8,0,3.6,0.4,5.2,1"/>
    </svg>
  )
}

export default ListCheck
